var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIraIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21350_8904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6706 23.9997C12.3019 23.9997 12.0039 23.7017 12.0039 23.333V17.4997C12.0039 17.131 12.3019 16.833 12.6706 16.833C13.0392 16.833 13.3372 17.131 13.3372 17.4997V23.333C13.3372 23.7017 13.0392 23.9997 12.6706 23.9997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6707 12C15.568 12 14.6707 11.1027 14.6707 10C14.6707 8.89733 15.568 8 16.6707 8C17.7733 8 18.6707 8.89733 18.6707 10C18.6707 11.1027 17.7733 12 16.6707 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8841 24.0003H16.6668C16.2988 24.0003 16.0001 23.7017 16.0001 23.3337V16.5003L14.6961 17.481C14.4334 17.715 14.1121 17.8643 13.7648 17.9143L12.7341 18.0637C12.3841 18.115 12.0274 18.0097 11.7594 17.777C11.4901 17.543 11.3354 17.2043 11.3354 16.8463C11.3354 16.379 11.5941 15.9577 12.0101 15.7483L13.8661 14.8117C13.9881 14.7503 14.0914 14.6583 14.1668 14.5443L14.5041 14.035C15.0694 13.181 16.0261 12.667 17.0508 12.667H17.7968C18.2601 12.667 18.6968 12.8397 19.0241 13.153C20.0948 14.1737 20.6174 15.9017 20.6681 18.591C20.6821 19.3443 20.4668 20.0783 20.0448 20.7157L19.8388 21.0263C19.5421 21.4743 19.3834 21.9997 19.3834 22.537V23.501C19.3841 23.7763 19.1601 24.0003 18.8841 24.0003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21350_8904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIraIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ira_icon.e705449a0bbde05cc98c6d356ca91ae8.svg";